import type {FormValues} from './types';

export const getHasError = (
    validation:
        | {
              [key: string]: boolean;
          }
        | null
        | undefined,
    field: string
): boolean => {
    return Boolean(validation && validation[field] === false);
};

export const checkFormValidity = (input: FormValues): boolean => {
    const {
        paymentType,
        email,
        companyName,
        agree,
        phone,
        address1,
        city,
        state,
        postal_code,
        country,
        first_name,
        last_name,
        routing_number,
        account_number,
        account_number_confirmation,
        account_type,
        name_on_account,
    } = input;

    let arePaymentFieldsValid = false;
    if (paymentType === 'card') {
        arePaymentFieldsValid = Boolean(first_name.length > 0 && last_name.length > 0);
    }

    if (paymentType === 'bank') {
        arePaymentFieldsValid = Boolean(
            routing_number.length > 0 &&
                account_number.length > 0 &&
                account_number_confirmation.length > 0 &&
                account_type.length > 0 &&
                name_on_account.length > 0
        );
    }

    const areOtherFieldsValid = Boolean(
        email.length > 0 &&
            companyName.length > 0 &&
            agree &&
            phone.length > 0 &&
            address1.length > 0 &&
            city.length > 0 &&
            state.length > 0 &&
            postal_code.length > 0 &&
            country.length > 0
    );

    return Boolean(arePaymentFieldsValid && areOtherFieldsValid);
};
